import { render, staticRenderFns } from "./doctorStatistics.vue?vue&type=template&id=94e735e8&scoped=true"
import script from "./doctorStatistics.vue?vue&type=script&lang=js"
export * from "./doctorStatistics.vue?vue&type=script&lang=js"
import style0 from "./doctorStatistics.vue?vue&type=style&index=0&id=94e735e8&prod&scoped=true&lang=css"
import style1 from "./doctorStatistics.vue?vue&type=style&index=1&id=94e735e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e735e8",
  null
  
)

export default component.exports